import React from "react";
import { faChild } from "@fortawesome/free-solid-svg-icons";
import { StyledFontAwesomeIcon } from "./styled";

const LoadingPage = () => {
    
    return (
        <>
            <StyledFontAwesomeIcon icon={faChild} />
        </>
    )

};

export default LoadingPage;